/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_BackInputs */

const vi_cdo_back = /** @type {(inputs: Cdo_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quay lại`)
};

/**

* @param {Cdo_BackInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_back = /** @type {((inputs?: Cdo_BackInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_BackInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_back(inputs)
});